import { usePdfViewerIdentity } from '../pdfViewer/usePdfViewerIdentity';
import { CoveredEntityGrid } from './CoveredEntityGrid';
import type { EntraGroupSearchResult } from './EntraGroupDisplayNameField';
import type { PatientTrackingCsvImportConfig } from './patientTrackingTypes';

export interface CoveredEntityListPageProps {
  currentUserId?: string;
  csvImport?: PatientTrackingCsvImportConfig;
  searchPortalAlertGroups?: (query: string) => Promise<EntraGroupSearchResult[]>;
  stateStorageKey?: string;
}

/** Covered Entity alerting list page (green=Active / red=Inactive rows, unique-name enforced). */
export function CoveredEntityListPage({
  currentUserId,
  csvImport,
  searchPortalAlertGroups,
  stateStorageKey
}: CoveredEntityListPageProps) {
  const identity = usePdfViewerIdentity(!currentUserId);
  const userId = currentUserId ?? identity.userId;
  const userName = identity.userName;
  const userAliases = identity.userAliases;

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <CoveredEntityGrid
          currentUserId={userId}
          currentUserName={userName}
          currentUserAliases={userAliases}
          csvImport={csvImport}
          searchPortalAlertGroups={searchPortalAlertGroups}
          stateStorageKey={stateStorageKey}
        />
      </div>
    </div>
  );
}
